





















































































































import { Component, Vue } from 'vue-property-decorator';
import DmqCartRetailerSection from '@/components/DmqCartRetailerSection.vue';
import DmqCartRetailerSummary from '@/components/DmqCartRetailerSummary.vue';
import store from '@/store';
import {Action, getModule} from 'vuex-module-decorators';
import CartModule from '@/store/modules/cart-module';
import { currency } from '@/utils/filters';
import api from "@/api";
import DmqModal from '@/components/DmqModal.vue';

enum RetPromoCode {
  CODE_INVALID = 1,
  CODE_VALID = 2,
  CODE_VALID_EXCEEDS = 3,
  CODE_ERROR = 4
}

enum TypeReducPromoCode {
  FIXED = "fixed_price",
  POURCENT = "percentage",
}

const cartModule = getModule(CartModule, store);

  @Component({
    components: {
      DmqCartRetailerSummary,
      DmqCartRetailerSection,
      DmqModal
    },
    filters: {
      currency,
    },
  })
  export default class DmqCart extends Vue {
    private collapse: boolean = false;
    private modalOrderCompleted: boolean = false;

    mounted() {
      if(this.alreadyHasPromoCode && this.codeIsValid(this.orderLinePromoCodeRetCode)) {
        this.promoCodeClass.code = this.orderLinePromoCode;
        this.promoCodeCart.code = this.orderLinePromoCode;
        this.promoCodeCart.retCode = this.orderLinePromoCodeRetCode;
        this.promoCodeCart.message = this.orderLinePromoCodeMessage;
        this.promoCodeCart.reduction = this.orderLinePromoCodeReduction;
        this.promoCodeCart.typeReduction = this.orderLinePromoCodeTypeReduction;
        this.toggleHeader()
      }
    }

    private get cart() {
      return cartModule.cart;
    }

    private get embed() {
      return cartModule.cart.embed ? cartModule.cart.embed : false;
    }

    private get promoCodeClass() {
      return cartModule.promoCode;
    }

    private get alreadyHasPromoCode() {
      return cartModule.cart.codePromoRetCode !== 0;
    }

    private get orderLinePromoCode() {
      let ret = '';
      if(this.alreadyHasPromoCode) {
        ret = cartModule.cart.codePromo;
      }
      return ret;
    }

    private get orderLinePromoCodeRetCode() {
      let ret = 0;
      if(this.alreadyHasPromoCode) {
        ret = cartModule.cart.codePromoRetCode;
      }
      return ret;
    }

    private get orderLinePromoCodeMessage() {
      let ret = '';
      if(this.alreadyHasPromoCode) {
        ret = cartModule.cart.codePromoMessage;
      }
      return ret;
    }

    private get orderLinePromoCodeReduction() {
      let ret = 0;
      if(this.alreadyHasPromoCode) {
        ret = cartModule.cart.codePromoReduction;
      }
      return ret;
    }

    private get orderLinePromoCodeTypeReduction() {
      let ret = '';
      if(this.alreadyHasPromoCode) {
        ret = cartModule.cart.codePromoTypeReduction;
      }
      return ret;
    }

    private get promoCodeCart() {
      return this.cart.promocode;
    }

    // Return code of promotional code
    private get promoCodeRetCode() {
      let ret = -1;
      if(this.promoCodeCart && this.promoCodeCart.retCode) {
        ret = this.promoCodeCart.retCode;
      }
      return ret;
    }

    // Return message to display
    private get promoCodeMessage() {
      let ret = '';
      if(this.promoCodeCart && this.promoCodeCart.message) {
        ret = this.promoCodeCart.message
      }
      return ret;
    }

    // Reduction
    private get promoCodeReduction() {
      let ret = 0;
      if(this.promoCodeCart && this.promoCodeCart.reduction) {
        ret = this.promoCodeCart.reduction
      }
      return ret;
    }

    // Type of reduction
    private get promoCodeTypeReduction() {
      let ret = '';
      if(this.promoCodeCart && this.promoCodeCart.typeReduction) {
        ret = this.promoCodeCart.typeReduction
      }
      return ret;
    }

    private codeIsValid(retCode:number) {
      return [RetPromoCode.CODE_VALID, RetPromoCode.CODE_VALID_EXCEEDS].includes(retCode);
    }

    private get promoCodeReductionLine() {
      let ret = '';
      const retCode = this.promoCodeRetCode;
      if(retCode) {
        if(this.codeIsValid(retCode)) {
          const reduction = Math.round(this.promoCodeReduction * 100) / 100;
          const typeReduction = this.promoCodeTypeReduction;
          if(this.promoCodeTypeReduction === TypeReducPromoCode.FIXED) {
            ret = "-CHF " + reduction.toFixed(2);
          } else if(typeReduction === TypeReducPromoCode.POURCENT) {
            ret = "-" + reduction + "%";
          }
        }
      }
      return ret;
    }

    private btnSetPromotionalCode() {
      const code = this.promoCodeClass.code;
      const promoCode = this.promoCodeCart;

      if(code) {
        cartModule.setPromotialCode(code).then((ret1) => {
          if(this.codeIsValid(ret1.retCode)) {
            cartModule.getPromotialCodeProductId().then((ret2) => {
              cartModule.add_promocode_line({
                productId: ret2.promoCodeProductId,
                quantity:1,
                code:this.promoCodeCart.code,
                retCode: this.promoCodeCart.retCode,
                message: this.promoCodeCart.message,
                reduction: this.promoCodeCart.reduction,
                typeReduction: this.promoCodeCart.typeReduction,
              });
            });
          }
        });
      }
    }

    private get intendedAmountTotal() {
      let res = this.cart.amountSubtotalTotal;
      let reduction = 0;

      for (const rs of this.cart.retailerSections) {
        res += rs.intendedDeliveryFees;
      }

      if(this.promoCodeCart && this.promoCodeCart.reduction) {
        reduction = this.promoCodeCart.reduction;
        if (reduction !== 0 && reduction < 0) {
          reduction = reduction * -1
        }
      }

      if (reduction > 0) {
        res -= reduction;
      }

      return res;
    }

    private toggleHeader() {
      this.collapse = !this.collapse;
      return this.collapse;
    }

    private toggleModalOrderCompleted() {
      this.modalOrderCompleted = !this.modalOrderCompleted;
      return this.modalOrderCompleted;
    }

    private reload() {
      window.location.href = document.referrer;
    }

    private promocodeExpanded() {
      return this.collapse;
    }

    private promocodeCollapsed() {
      return !this.collapse;
    }

    private promocodeMessageValid() {
      return this.codeIsValid(this.promoCodeRetCode);
    }

    private promocodeMessageError() {
      return !(this.codeIsValid(this.promoCodeRetCode));
    }

    private getOrderCompleted(interval: number) {
      api.get('cart/order_completed/' + cartModule.cart.id).then((r) => {
        if(r.data.orderIsCompleted === 1) {
          clearInterval(interval);
          this.toggleModalOrderCompleted();
        }
      }, (error) => {
        // error
        console.log(error);
      });
    }

    private orderCompleted() {
      if(this.embed) {
        let interval = setInterval(() => {
          this.getOrderCompleted(interval);
        }, 2000);
        window.open('/shop/address', '_blank');
      } else {
        window.location.href = '/shop/address';
      }
    }
  }

